import { styled } from "@mui/material";

export const StyledStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#EFEFEF",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  border: "solid",
  borderColor: "#979797",
  ...(ownerState.active && {
    border: "solid",
    borderColor: "#1460AA",
    backgroundImage: "linear-gradient( #C6E8F6 0%, #C6E8F6 0%, #C6E8F6 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage: "linear-gradient( #0074d9 0%, #0074d9 0%, #0074d9 100%)",
    border: "none",
  }),
}));
